export const careersFaqs = [
    {
      id: 1,
      question: "How can I apply for open positions?",
      answer: "You can apply directly through our Careers page or send your resume via email."
    },
    {
      id: 2,
      question: "Do you offer internships?",
      answer: "Yes, we have internship programs for developers, designers, and marketing students."
    },
    {
      id: 3,
      question: "Is remote work available?",
      answer: "Yes, we support both hybrid and remote work options."
    }
  ]
  